var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-alert',{staticStyle:{"justify-content":"center","font-size":"1rem","border-radius":"0px"},attrs:{"variant":"success","dismissible":""},on:{"dismissed":_vm.setEditExamSuccess},model:{value:(_vm.countdown),callback:function ($$v) {_vm.countdown=$$v},expression:"countdown"}},[_vm._v(" Success! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }